import {UserRole} from 'common/report/util/saved-entities/types';
import {TranslationKey} from 'common/i18n';

export const UserRoleI18nKey: Record<UserRole, TranslationKey> = {
  [UserRole.Admin]: `mixology.user-role.admin`,
  [UserRole.Analyst]: `mixology.user-role.analyst`,
  [UserRole.BillingAdmin]: `mixology.user-role.billing-admin`,
  [UserRole.Consumer]: `mixology.user-role.consumer`,
  [UserRole.Member]: `mixology.user-role.member`,
  [UserRole.Messenger]: `mixology.user-role.messenger`,
  [UserRole.Owner]: `mixology.user-role.owner`,
};

export const UserRoleProjectDescriptionI18nKey: Record<UserRole, TranslationKey | undefined> = {
  [UserRole.Admin]: `settings.user-role.project-description.admin`,
  [UserRole.Analyst]: `settings.user-role.project-description.analyst`,
  [UserRole.BillingAdmin]: `settings.user-role.project-description.billing-admin`,
  [UserRole.Consumer]: `settings.user-role.project-description.consumer`,
  [UserRole.Member]: undefined,
  [UserRole.Messenger]: `settings.user-role.project-description.messenger`,
  [UserRole.Owner]: `settings.user-role.project-description.owner`,
};

export const UserRoleOrgDescriptionI18nKey: Record<UserRole, TranslationKey> = {
  [UserRole.Admin]: `settings.user-role.org-description.admin`,
  [UserRole.Analyst]: `settings.user-role.org-description.analyst`,
  [UserRole.BillingAdmin]: `settings.user-role.org-description.billing-admin`,
  [UserRole.Consumer]: `settings.user-role.org-description.consumer`,
  [UserRole.Member]: `settings.user-role.org-description.member`,
  [UserRole.Messenger]: `settings.user-role.org-description.messenger`,
  [UserRole.Owner]: `settings.user-role.org-description.owner`,
};
